import { useLanguage } from "@/contexts/LanguageContext";
import { ScanEye, Handshake, ShieldCheck, ChevronRight } from "lucide-react";

const ServicesSection = () => {
  const { t } = useLanguage();

  const steps = [
    { icon: ScanEye, ...t.services.aiAnalysis, step: "01" },
    { icon: Handshake, ...t.services.negotiation, step: "02" },
    { icon: ShieldCheck, ...t.services.legal, step: "03" },
  ];

  return (
    <section className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground text-center mb-16">
          {t.services.title}
        </h2>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-0 items-stretch">
          {steps.map((item, i) => (
            <div key={i} className="relative flex items-stretch">
              <div className="relative bg-card border border-border rounded-2xl p-8 shadow-lg hover:border-primary/40 transition-colors group flex-1">
                <span className="absolute top-4 right-4 text-2xl font-extrabold text-primary">{item.step}</span>
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                  <item.icon className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-lg font-bold text-foreground mb-3">{item.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
              </div>
              {/* Arrow connector */}
              {i < steps.length - 1 && (
                <div className="hidden md:flex items-center justify-center w-8 -mx-4 z-10">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <ChevronRight className="h-4 w-4 text-primary" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
